import { uid } from 'uid/secure';

export const generateId = (prefix?: string): string => {
  const randomId = uid();
  if (!prefix) return randomId;
  return `${prefix}-${randomId}`;
};
